module.exports = __webpack_public_path__ + "static/media/text-1.80ec211e_back.png";